var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAeroplane1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 147,
    viewBox: "0 0 148 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2154_829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.604 79.2562C124.278 82.8519 121.12 85.4839 117.558 85.1297L93.8503 82.9771L69.1773 115.485L60.5509 114.732L74.4977 81.2507L50.7295 79.0925L43.5169 87.1323L37.0291 86.5126L42.723 71.8522L39.7683 56.3452L46.2948 56.8764L51.9913 66.2112L75.5767 68.3527L67.9881 32.8234L76.6089 33.6369L95.0234 70.057L118.731 72.2095C122.21 72.464 124.981 75.7879 124.604 79.2562Z",
    fill: "#E0E0E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2154_829"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.6387,
    y: 0.0842896,
    width: 103.851,
    height: 103.851,
    rx: 51.9255,
    transform: "rotate(50.1881 80.6387 0.0842896)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeroplane1);
export default __webpack_public_path__ + "static/media/aeroplane1.cf145b14e4337f9fd9725e54b4f96497.svg";
export { ForwardRef as ReactComponent };